<h2 mat-dialog-title>Novo impedimento</h2>

<mat-dialog-content>
  <div class="flex flex-col gap-4">
    @if (!motoristaSelecionado) {
    <div class="flex items-end gap-2">
      <mat-form-field class="input-tg w-full" appearance="outline">
        <mat-label>Buscar motorista por nome</mat-label>
        <input matInput [(ngModel)]="buscaMotorista" [ngModelOptions]="{ standalone: true }"
          (keyup.enter)="buscarMotorista()" />
      </mat-form-field>
      <button mat-flat-button class="btn-tg" (click)="buscarMotorista()">
        <mat-icon>search</mat-icon>
        Buscar
      </button>
    </div>

    @if (buscandoMotorista) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    @if (resultadosMotorista.length > 0) {
    <div class="flex flex-col border rounded">
      @for (motorista of resultadosMotorista; track motorista.id) {
      <button type="button" class="flex justify-between items-center px-4 py-2 hover:bg-gray-100 text-left w-full"
        (click)="selecionarMotorista(motorista)">
        <span>{{ motorista.nome }}</span>
        <span class="text-gray-500 text-sm">{{ motorista.cpf }}</span>
      </button>
      }
    </div>
    } @else if (buscaMotorista && !buscandoMotorista) {
    <div class="text-center text-gray-500 py-2">Nenhum motorista encontrado. Aperte Enter ou Buscar.</div>
    }
    } @else {
    <div class="flex justify-between items-center">
      <div class="text-lg font-semibold">{{ motoristaSelecionado.nome }}</div>
      <button mat-button class="btn-tg-cancel" (click)="trocarMotorista()">Trocar motorista</button>
    </div>

    <div [formGroup]="form" class="flex flex-col gap-2">
      <div class="flex justify-between gap-4 items-center">
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="tipoImpedimentoId">
            @for (tipo of tiposImpedimento; track tipo.id) {
            <mat-option [value]="tipo.id">{{ tipo.descricao }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>Data início</mat-label>
          <input matInput [matDatepicker]="dataInicio" formControlName="dataInicio" />
          <mat-datepicker-toggle matIconSuffix [for]="dataInicio"></mat-datepicker-toggle>
          <mat-datepicker #dataInicio></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>Data fim</mat-label>
          <input matInput [matDatepicker]="dataFim" formControlName="dataFim" />
          <mat-datepicker-toggle matIconSuffix [for]="dataFim"></mat-datepicker-toggle>
          <mat-datepicker #dataFim></mat-datepicker>
        </mat-form-field>
      </div>

      @if (exigeJanelaHora) {
      <div class="flex justify-between gap-4 items-center">
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>Hora início</mat-label>
          <input matInput type="time" formControlName="horaInicio" />
        </mat-form-field>
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>Hora fim</mat-label>
          <input matInput type="time" formControlName="horaFim" />
        </mat-form-field>
        <div class="w-4/12 text-sm text-gray-500">Sem a janela, o impedimento bloquearia o dia inteiro.</div>
      </div>
      }

      <mat-form-field class="input-tg w-full" appearance="outline">
        <mat-label>Observação</mat-label>
        <input matInput formControlName="observacao" />
      </mat-form-field>
    </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button class="btn-tg-white" (click)="cancelar()">Cancelar</button>
  @if (motoristaSelecionado) {
  <button mat-flat-button class="btn-tg" [disabled]="salvando" (click)="adicionar()">
    @if (salvando) {
    <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
    } @else {
    Adicionar impedimento
    }
  </button>
  }
</mat-dialog-actions>
